<template>
  <div>
    <el-card>
      <div class="flex flex-align-center flex-wrap gap-20">
        <div class="flex flex-align-center gap-10">
          <div class="keyLabel">关键字：</div>
          <el-input v-model="keywords" placeholder="商品名称、规格条形码" style="width:250px"></el-input>
        </div>
        <el-button type="primary" @click="handleCurrentChange(1)">查询</el-button>
      </div>
      <div class="margin-top-10">
        <el-table :data="tablelist" v-loading="tableloading">
          <el-table-column prop="" label="商品" min-width="200">
            <template slot-scope="scope">
              <div class="flex flex-align-center gap-10">
                <img :src="scope.row.ImgUrlComplete" style="width:60px;height:60px" alt="">
                <div class="ellipsis">
                  {{scope.row.Name}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="规格">
            <template slot-scope="scope">
              <div class="ellipsis">
                {{scope.row.SpecValue||'默认规格'}}
                <span v-if="scope.row.SpecValue2">;{{scope.row.SpecValue2}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="规格编码">
            <template slot-scope="scope">
              <div class="ellipsis">
                {{scope.row.Barcode||'--'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="分销价(元)">
            <template slot-scope="scope">
              <div v-if="scope.row.DistributePriceId">
                <div>企店分销价：{{scope.row.QiDianDistributePrice}}</div>
                <div>一级分销价：{{scope.row.FirstLevelDistributePrice}}</div>
                <div>二级分销价：{{scope.row.SecondLevelDistributePrice}}</div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="特价分销商">
            <template slot-scope="scope">
              <div>
                <el-button type="text" v-if="scope.row.SpecialPriceDistributorCount"
                   @click="setSpecialPrice(scope.row)">{{scope.row.SpecialPriceDistributorCount}}</el-button>
                <div class="flex flex-align-center" v-else>
                  <span>0</span>
                  <el-button type="text" class="margin-left-5" @click="setSpecialPrice(scope.row)">设置</el-button>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作" width="120">
            <template slot-scope="scope">
              <div>
                <buttonPermissions :datas="'XITAIShopDistributionPriceSet'">
                  <el-button type="text" @click="setPrice(scope.row)">设置分销价</el-button>
                </buttonPermissions>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align:right;margin-top:10px" v-if="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

    <el-dialog :visible.sync="specialShow" title="商品分销商特价" custom-class="dialog-body-paddingTop-10" width="800px" v-loading="specialLoading">
      <div class="flex flex-align-center flex-justify-between">
        <div class="font-14 color-606266">商品：{{rowmsg.Name}}{{rowmsg.SpecValue?('-'+rowmsg.SpecValue):''}}{{rowmsg.SpecValue2?(';'+rowmsg.SpecValue2):''}} 
          <span v-if="rowmsg.Barcode">({{rowmsg.Barcode}})</span> </div>
        <el-button type="text" @click="openChoose">选择分销商</el-button>
      </div>
      <el-table :data="specialList" max-height="500">
        <el-table-column prop="" label="分销商">
          <template slot-scope="scope">
            <div>
              <div class="ellipsis color-606266">{{scope.row.EmployeeName}}</div>
              <div class="color-999999">{{scope.row.Phone}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="分销商特价">
          <template slot-scope="scope">
            <div>
              <el-input v-model="scope.row.SpecialPrice" style="width:150px"
                oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))">
                <template slot="append">元</template>
              </el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="AddTime" label="添加时间"></el-table-column>
        <el-table-column prop="" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" style="color:#f56c6c" @click="delRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="text-align:right;margin-top:10px" v-if="total2"
        @size-change="(e)=>{currentPage2=1,pagesize2=e,getCurrentList()}"
        @current-change="(e)=>{currentPage2=e,getCurrentList()}"
        :current-page="currentPage2"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pagesize2"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total2">
      </el-pagination>
      <div class="flex flex-align-center margin-top-20">
        <el-button style="margin-left:auto" @click="specialShow=false">关闭</el-button>
        <el-button type="primary" @click="confirmSave">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="chooseShow" title="选择分销商" custom-class="dialog-body-paddingTop-10" width="800px">
      <div class="flex flex-align-center gap-10">
        <div class="flex flex-align-center gap-10">
          <div class="keyLabel">关键字：</div>
          <el-input v-model="chooseKeywords" placeholder="分销商名称、分销商帐号" style="width:250px"></el-input>
        </div>
        <el-button type="primary" @click="currentPage3=1,getchooseTableList()">查询</el-button>
      </div>
      <el-table :data="chooseTable" v-loading="chooseLoading" row-key="Id" @selection-change="handleSelectionChange" class="margin-top-20"
       ref="table" v-if="chooseShow" max-height="500">
        <el-table-column type="selection" width="55" reserve-selection></el-table-column>
        <el-table-column prop="" label="分销商">
          <template slot-scope="scope">
            <div class="ellipsis">
              {{scope.row.EmployeeName}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Phone" label="分销商帐号"></el-table-column>
        <el-table-column prop="DistributionLevelValue" label="分销商级别"></el-table-column>
      </el-table>
      <el-pagination style="text-align:right;margin-top:10px" v-if="total3"
        @size-change="(e)=>{currentPage3=1,pagesize3=e,getchooseTableList()}"
        @current-change="(e)=>{currentPage3=e,getchooseTableList()}"
        :current-page="currentPage3"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pagesize3"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total3">
      </el-pagination>
      <div class="flex flex-align-center margin-top-20">
        <el-button style="margin-left:auto" @click="chooseShow=false">关闭</el-button>
        <el-button type="primary" @click="confirmChoose">确认选择</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="setShow" title="设置分销价" custom-class="dialog-body-paddingTop-10" width="450px">
      <div class="form" style="margin-top:0px">
        <div class="flex flex-align-center">
          <div class="form-label label-star">企店分销价：</div>
          <el-input v-model="rowmsg.QiDianDistributePrice" placeholder="西苔对企店供货价"
            oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))">
            <template slot="append">元</template>
          </el-input>
        </div>
        <div class="flex flex-align-center margin-top-20">
          <div class="form-label label-star">一级分销价：</div>
          <el-input v-model="rowmsg.FirstLevelDistributePrice" placeholder="企店对一级分销商供货价"
            oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))">
            <template slot="append">元</template>
          </el-input>
        </div>
        <div class="flex flex-align-center margin-top-20">
          <div class="form-label label-star">二级分销价：</div>
          <el-input v-model="rowmsg.SecondLevelDistributePrice" placeholder="企店对二级分销商供货价"
            oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))">
            <template slot="append">元</template>
          </el-input>
        </div>
        <div class="flex-align-center margin-top-20" style="text-align:right">
          <el-button @click="setShow=false">关闭</el-button>
          <el-button type="primary" @click="confirmSet">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import buttonPermissions from '@/components/buttonPermissions';
import {
  cittaDistributioncittaDistributionProductList,
  cittaDistributioncittaDistributionProductPrice,
  cittaDistributioncittaDistributionProductPriceSave,
  cittaDistributioncittaDistributionProductSpecialPriceList,
  cittaDistributiondistributorList,
  cittaDistributioncittaDistributionProductSpecialPriceSave
} from "@/api/sv3.0.0"
export default {
  components: {
    buttonPermissions
  },
  data () {
    return {
      keywords:'',
      tablelist:[],
      tableloading:false,
      currentPage:1,
      pagesize:20,
      total:0,
      rowmsg:{},
      specialShow:false,
      specialLoading:false,
      allspecialList:[],
      specialList:[],
      currentPage2:1,
      pagesize2:10,
      total2:0,
      chooseShow:false,
      chooseKeywords:'',
      chooseTable:[],
      chooseLoading:false,
      chooseList:[],
      currentPage3:1,
      pagesize3:10,
      total3:0,
      setShow:false,
      isFirst:true,
    }
  },
  mounted () {
    this.gettablelist()
  },
  methods: {
    openChoose(){
      this.isFirst = true
      this.chooseList = []
      this.getchooseTableList()
      this.chooseShow=true
    },
    async confirmSet(){
      if(!String(this.rowmsg.QiDianDistributePrice)||this.rowmsg.QiDianDistributePrice<0||this.rowmsg.QiDianDistributePrice>99999||
         !String(this.rowmsg.FirstLevelDistributePrice)||this.rowmsg.FirstLevelDistributePrice<0||this.rowmsg.FirstLevelDistributePrice>99999||
         !String(this.rowmsg.SecondLevelDistributePrice)||this.rowmsg.SecondLevelDistributePrice<0||this.rowmsg.SecondLevelDistributePrice>99999){
        this.$message.error('价格请输入在0~99999元之间')
        return
      }
      try{
        let res = await cittaDistributioncittaDistributionProductPriceSave({
          Info:this.rowmsg
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.setShow = false
          this.gettablelist()
        }
      }finally{
        //
      }
    },
    async setPrice(row){
      this.tableloading = true
      try{
        let res = await cittaDistributioncittaDistributionProductPrice({
          ProductId:row.ProductId
        })
        if(res.IsSuccess){
          this.rowmsg = {
            ...res.Result,
            QiDianDistributePrice:res.Result.Id?res.Result.QiDianDistributePrice:'',
            FirstLevelDistributePrice:res.Result.Id?res.Result.FirstLevelDistributePrice:'',
            SecondLevelDistributePrice:res.Result.Id?res.Result.SecondLevelDistributePrice:'',
          }
          this.setShow = true
        }
      }finally{
        this.tableloading = false
      }
    },
    confirmChoose(){
      let old = JSON.parse(JSON.stringify(this.allspecialList))
      this.allspecialList = JSON.parse(JSON.stringify(this.chooseList.map(v=>{
        let item = old.find(x=>x.Id==v.Id)
        v.SpecialPrice = ''
        if(item){
          v.AddTime = item.AddTime
          v.SpecialPrice = item.SpecialPrice
        }else{
          v.AddTime = this.gettime()
        }
        return v
      })))
      this.getCurrentList()
      this.chooseShow = false
    },
    gettime(){
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth()+1
      let day = date.getDate()
      let hour = date.getHours()
      let min = date.getMinutes()
      let sec = date.getSeconds()
      return year+'-'+(month>9?month:('0'+month))+'-'+(day>9?day:('0'+day))+' '+(hour>9?hour:('0'+hour))+':'+(min>9?min:('0'+min))+':'+(sec>9?sec:('0'+sec))
    },
    async getchooseTableList(){
      try{
        this.chooseLoading = true
        let res = await cittaDistributiondistributorList({
          EmployeeState:1,
          Skip:(this.currentPage3-1)*this.pagesize3,
          Take:this.pagesize3,
          Keywords:this.chooseKeywords
        })
        if(res.IsSuccess){
          this.chooseTable = res.Result.Results
          this.total3 = res.Result.Total
          if(this.isFirst){
            this.$nextTick(()=>{
              this.allspecialList.forEach(x=>{
                this.$refs.table.toggleRowSelection(x)
              })
              this.getchooseTableList()
            })
            this.isFirst = false
          }
        }
      }finally{
        this.chooseLoading = false
      }
    },
    handleSelectionChange(e){
      this.chooseList = e
    },
    async confirmSave(){
      for(let item of this.allspecialList){
        if(!String(item.SpecialPrice)||item.SpecialPrice<0||item.SpecialPrice>99999){
          this.$message.error('价格请输入在0~99999元之间')
          return
        }
      }
      try{
        this.specialLoading = true
        let res = await cittaDistributioncittaDistributionProductSpecialPriceSave({
          ProductId:this.rowmsg.ProductId,
          SpecialPriceList:this.allspecialList
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.specialShow = false
          this.gettablelist()
        }
      }finally{
        this.specialLoading = false
      }
    },
    getCurrentList(){
      this.total2 = this.allspecialList.length
      let list = []
      list = this.allspecialList.filter((v,i)=>{
        return i>=(this.currentPage2-1)*this.pagesize2&&i<this.currentPage2*this.pagesize2
      })
      if(!list.length&&this.currentPage2>1){
        this.currentPage2--
        this.getCurrentList()
        return 
      }
      this.specialList = list
    },
    delRow(row){
      this.allspecialList = this.allspecialList.filter(v=>{
        return v.Id!=row.Id
      })
      this.chooseList = this.allspecialList
      this.getCurrentList()
    },
    async setSpecialPrice(row){
      if(!row.DistributePriceId){
        this.$message.error('请先配置基础分销价')
        return 
      }
      try{
        this.specialLoading = true
        let res = await cittaDistributioncittaDistributionProductSpecialPriceList({
          ProductId:row.ProductId,
        })
        if(res.IsSuccess){
          this.allspecialList = res.Result
          this.rowmsg = JSON.parse(JSON.stringify(row))
          this.getCurrentList()
          this.specialShow = true
        }
      }finally{
        this.specialLoading = false
      }
    },
    handleSizeChange(e){
      this.currentPage = 1
      this.pagesize = e
      this.gettablelist()
    },
    handleCurrentChange(e){
      this.currentPage = e
      this.gettablelist()
    },
    async gettablelist(){
      try{
        this.tableloading = true
        let data = {
          Keywords:this.keywords,
          CittaDistributionId:null,
          Skip:(this.currentPage-1)*this.pagesize,
          Take:this.pagesize
        }
        let res = await cittaDistributioncittaDistributionProductList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
}
</script>

<style lang='less' scoped>

</style>